"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const antd_1 = require("antd");
function getErrors(validationError, key) {
    const errors = validationError && validationError.errors && validationError.errors[key];
    if (!errors) {
        return null;
    }
    return errors.map((error) => new Error(error));
}
function mapValidationToFields(model, validationError = null) {
    const formFields = {};
    if (!model) {
        return formFields;
    }
    return getPlainFields(model, validationError, formFields);
}
function getPlainFields(model, validationError = null, formFields, oldKey) {
    if (!model) {
        return formFields;
    }
    for (const [key, value] of Object.entries(model)) {
        const newKey = oldKey ? `${oldKey}.${key}` : key;
        if (typeof value === 'object') {
            getPlainFields(value, validationError, formFields, newKey);
        }
        else {
            formFields[newKey] = antd_1.Form.createFormField({
                value,
                errors: getErrors(validationError, newKey)
            });
        }
    }
    return formFields;
}
function mapModelToFields(branch) {
    const { data, errors } = branch;
    const validationError = errors
        ? Object.assign({ status: 422, message: '' }, errors)
        : null;
    return mapValidationToFields(data, validationError);
}
exports.mapModelToFields = mapModelToFields;
exports.AntdFormHelper = {
    mapValidationToFields,
    mapModelToFields
};
//# sourceMappingURL=AntdFormHelpers.js.map